export default __webpack_public_path__ + "static/media/proecting.b6864af8.svg";